export var RoleTypes = {
    manager: "MANAGER",
    authority: "AUTHORITY",
    wrestler: "WRESTLER",
    referee: "REFEREE",
    owner: "OWNER",
    commentator: "COMMENTATOR",
    retired: "RETIRED",
    announcer: "ANNOUNCER",
    host: "HOST",
    interviewer: "INTERVIEWER"
};
export var GeneralManagers = {
    NONE: {
        id: "vacant",
        name: "Vacant",
        image: ""
    },
    ONE: {
        id: "vince-mcmahon",
        name: "Vince McMahon",
        image: "//i2-prod.dailystar.co.uk/news/latest-news/article24554686.ece/ALTERNATES/s615b/3_SD_07162021RF_23861-ca45e7ff2c071a0bd994998a07da72a4.jpg"
    },
    TWO: {
        id: "tony-khan",
        name: "Tony Khan",
        image: "//411mania.com/wp-content/uploads/2022/03/AEW-Dynamite-Tony-Khan-645x370.png"
    },
    THREE: {
        id: "johhny",
        name: "John Laurinaitis",
        image: "//staticg.sportskeeda.com/editor/2022/03/5c555-16483880962779-1920.jpg"
    }
};
export var BuildTypes = {
    FAT: "Fat",
    RIPPED: "Ripped",
    HENCH: "Hench",
    HOSS: "Hoss",
    AVERAGE: "Average"
};
export var StyleTypes = {
    TECHNICAL: "Technical",
    POWERHOUSE: "Powerhouse",
    HOSS: "Hoss",
    SUBMISSION: "Submission"
};
export var brandRoles = [
    {
        key: "announcerIds",
        label: "Announcers",
        role: RoleTypes.announcer,
        maxAmount: 2,
        filter: function(item) {
            return item.role === RoleTypes.announcer;
        }
    },
    {
        key: "interviewerIds",
        label: "Interviewers",
        role: RoleTypes.interviewer,
        maxAmount: 3,
        filter: function(item) {
            return item.role === RoleTypes.interviewer;
        }
    },
    {
        key: "commentatorIds",
        label: "Commentators",
        maxAmount: 4,
        role: RoleTypes.commentator,
        filter: function(item) {
            return item.role === RoleTypes.commentator;
        }
    },
    {
        key: "hostIds",
        label: "Hosts",
        maxAmount: 2,
        role: RoleTypes.host,
        filter: function(item) {
            return item.role === RoleTypes.host;
        }
    },
    {
        key: "refereeIds",
        label: "Referees",
        maxAmount: 4,
        role: RoleTypes.referee,
        filter: function(item) {
            return item.role === RoleTypes.referee;
        }
    },
    {
        key: "authorityIds",
        label: "Authority Figures",
        role: RoleTypes.authority,
        maxAmount: 4,
        filter: function(item) {
            return item.role === RoleTypes.authority;
        }
    },
    {
        key: "ownerIds",
        label: "Owners",
        role: RoleTypes.owner,
        maxAmount: 2,
        filter: function(item) {
            return item.role === RoleTypes.owner;
        }
    }
];
export var RolesOptions = Object.keys(RoleTypes).map(function(key) {
    return {
        id: key,
        value: RoleTypes[key],
        inactive: "".concat(key, "?"),
        active: key
    };
});
